'use client';
import React, { useState } from 'react';
import { FileText, Users, MapPin, AlertTriangle, Tag } from 'lucide-react';
import ClaimInfoSection from './ClaimInfoSection';
import FamilyMembersSection from './FamilyMembersSection';
import RoomsSection from './RoomsSection';
import DangerZoneSection from './DangerZoneSection';
import CategoriesSection from './CategoriesSection';
import Icon from '@/components/ui/AppIcon';


const TABS = [
  { key: 'tab-claim-info', id: 'claim-info', label: 'Claim Information', icon: FileText },
  { key: 'tab-members', id: 'members', label: 'Family Members', icon: Users },
  { key: 'tab-rooms', id: 'rooms', label: 'Rooms & Locations', icon: MapPin },
  { key: 'tab-categories', id: 'categories', label: 'Categories', icon: Tag },
  { key: 'tab-danger', id: 'danger', label: 'Danger Zone', icon: AlertTriangle },
];

export default function SettingsContent() {
  const [activeTab, setActiveTab] = useState('claim-info');

  return (
    <div className="space-y-6 fade-in">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-semibold text-foreground">Settings</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Configure your claim details, family members, and property rooms
        </p>
      </div>
      <div className="flex flex-col lg:flex-row gap-6">
        {/* Left nav */}
        <div className="lg:w-52 shrink-0">
          <nav className="space-y-1">
            {TABS?.map((tab) => {
              const Icon = tab?.icon;
              const isActive = activeTab === tab?.id;
              return (
                <button
                  key={tab?.key}
                  onClick={() => setActiveTab(tab?.id)}
                  className={[
                    'w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-left transition-all duration-150',
                    isActive
                      ? tab?.id === 'danger' ? 'bg-negative-bg text-negative' : 'bg-primary/10 text-primary' :'text-secondary-foreground hover:bg-secondary hover:text-foreground',
                  ]?.join(' ')}
                >
                  <Icon size={16} className="shrink-0" />
                  {tab?.label}
                </button>
              );
            })}
          </nav>
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="bg-card border border-border rounded-xl p-6">
            {activeTab === 'claim-info' && <ClaimInfoSection />}
            {activeTab === 'members' && <FamilyMembersSection />}
            {activeTab === 'rooms' && <RoomsSection />}
            {activeTab === 'categories' && <CategoriesSection />}
            {activeTab === 'danger' && <DangerZoneSection />}
          </div>
        </div>
      </div>
    </div>
  );
}